const COMMUNITY_ID = 'community';
const EXPIRED_STATUS = 'expired';

export const filterCommunityItems = (item, status, flags) =>
  !(item.id === COMMUNITY_ID && (status === EXPIRED_STATUS || flags?.length === 0));
